module.exports = __webpack_public_path__ + "img/docs_edit.22c44914.png";